module.exports = __webpack_public_path__ + "img/icon_img44.2e92d393.png";